import { PaginationProps, Table, TableProps } from "antd";
import { verificarPermissaoEmpresa } from "../../util/functions/verificarPermissaoEmpresa";
import { useAppDispatch } from "../../util/hooks";

export interface TableComponentPaginationProps {
  currentPage?: number;
  pageSize?: number;
  defaultPageSize?: number;
}

interface HeaderCellProps extends React.HTMLAttributes<HTMLTableCellElement> {
  id: string;
}

type TableComponentProps = {
  data: any[];
  columns: any[];
  loading?: boolean;
  rowKey?: string;
  pagination?: boolean;
  style?: React.CSSProperties;
  headerStyle?: any;
  expandable?: any;
  selectionType?: "checkbox" | "radio" | "radio-allowed";
  rowSelection?: (value: any) => void;
  virtualized?: boolean;
  stateReducer?: any;
  fetchReducer?: any;
  setReducer?: any;
  rowClassName?: (value: any) => void;
  tableProps?: any;
};

const TableComponent = ({
  data,
  columns,
  loading,
  rowKey = "id",
  pagination = true,
  headerStyle = { backgroundColor: "#334155", color: "#ffffff" },
  expandable,
  selectionType,
  rowSelection,
  virtualized = false,
  stateReducer,
  fetchReducer,
  setReducer,
  rowClassName,
  tableProps,
}: TableComponentProps) => {
  //hooks
  const dispatch = useAppDispatch();

  const TableHeaderCell: React.FC<HeaderCellProps> = (props) => {
    const style: React.CSSProperties = {
      ...props.style,
      ...headerStyle,
    };
    return <th {...props} style={style} />;
  };

  const onChangeTable = (event: any) => {
    if (virtualized && (stateReducer.pageNumber !== event.current || stateReducer.pageSize !== event.pageSize)) {
      dispatch(
        setReducer({
          ...stateReducer,
          pageNumber: event.current,
          pageSize: event.pageSize,
        })
      );
      dispatch(
        fetchReducer({
          ...stateReducer,
          pageNumber: event.current,
          pageSize: event.pageSize,
        })
      );
    }
  };

  const onRowSelection: TableProps["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      rowSelection?.({ keys: selectedRowKeys, rows: selectedRows });
    },
    getCheckboxProps: tableProps?.getCheckboxProps,
    hideSelectAll: tableProps?.hideSelectAll ?? false,
    selectedRowKeys: tableProps?.selectedRowKeys,
  };

  const onChangeCurrentPage: PaginationProps["onChange"] = (page, pageSize) => {
    if (!tableProps.setPaginationProps) return;
    const props: TableComponentPaginationProps = { currentPage: page, pageSize: pageSize };
    tableProps.setPaginationProps(props);
  };

  return (
    <Table
      size="small"
      rowKey={rowKey}
      components={{
        header: { cell: TableHeaderCell },
      }}
      dataSource={data}
      rowSelection={selectionType === "radio-allowed" ? { type: "radio", ...onRowSelection } : selectionType && verificarPermissaoEmpresa() ? { type: selectionType, ...onRowSelection } : false}
      columns={verificarPermissaoEmpresa() ? columns : columns.filter((column) => column.dataIndex !== "acoes")}
      loading={loading}
      onChange={onChangeTable}
      pagination={
        virtualized
          ? { defaultPageSize: stateReducer.pageSize, showSizeChanger: true, total: data[0]?.total }
          : pagination
          ? tableProps?.paginationProps
            ? {
                defaultPageSize: tableProps?.paginationProps?.defaultPageSize ?? 20,
                pageSize: tableProps?.paginationProps?.pageSize,
                showSizeChanger: true,
                current: tableProps?.paginationProps?.currentPage,
                onChange: onChangeCurrentPage,
              }
            : { defaultPageSize: 100, showSizeChanger: true }
          : false
      }
      scroll={{ x: "max-content" }}
      expandable={expandable}
      rowClassName={rowClassName}
      {...tableProps}
    />
  );
};

export default TableComponent;
